
import { CheckCircle } from "lucide-react";
import AnimatedCard from "@/components/AnimatedCard";

const WhatSetsUsApart = () => {
  return (
    <section className="py-20 bg-secondary">
      <div className="container mx-auto px-6">
        <AnimatedCard animation="fade-in" className="mb-10 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            What <span className="text-primary">Sets Us Apart</span>
          </h2>
        </AnimatedCard>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <AnimatedCard animation="slide-in-left">
            <div className="space-y-6">
              <p className="text-lg text-gray-300">
                We provide expert guidance that's grounded in independent research, deep technical 
                understanding, and a clear view of what actually works in legal environments. We're not 
                here to sell software — we're here to help your firm make smart decisions and move 
                forward with confidence.
              </p>
            </div>
          </AnimatedCard>
          
          <AnimatedCard animation="slide-in-right" delay={200}>
            <ul className="space-y-4">
              <li className="flex items-start">
                <div className="mt-1 bg-primary/20 p-2 rounded mr-3">
                  <CheckCircle className="h-5 w-5 text-primary" />
                </div>
                <div>
                  <p className="text-lg font-medium">AI use case evaluation for your firm</p>
                </div>
              </li>
              <li className="flex items-start">
                <div className="mt-1 bg-primary/20 p-2 rounded mr-3">
                  <CheckCircle className="h-5 w-5 text-primary" />
                </div>
                <div>
                  <p className="text-lg font-medium">Vendor-agnostic assessments</p>
                </div>
              </li>
              <li className="flex items-start">
                <div className="mt-1 bg-primary/20 p-2 rounded mr-3">
                  <CheckCircle className="h-5 w-5 text-primary" />
                </div>
                <div>
                  <p className="text-lg font-medium">Security and compliance strategy</p>
                </div>
              </li>
              <li className="flex items-start">
                <div className="mt-1 bg-primary/20 p-2 rounded mr-3">
                  <CheckCircle className="h-5 w-5 text-primary" />
                </div>
                <div>
                  <p className="text-lg font-medium">Infrastructure, integration, and change planning</p>
                </div>
              </li>
            </ul>
          </AnimatedCard>
        </div>
      </div>
    </section>
  );
};

export default WhatSetsUsApart;
